import useState from "react-usestateref";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";
import { AppBar, Drawer, ListItem, Toolbar } from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import "./style.css";
import { FaPhoneAlt } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import { useRef } from "react";
import { sendcontactpageContacts } from "../config/apiCall";
import httpService from "../config/httpCall";
import { makeStyles } from "@material-ui/core/styles";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const Contact = () => {
  const [activeSection, setActiveSection] = useState("about");
  const [value, setValue] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newformmediumErr, setnewformmediumErr] = useState(false);
  const [buttonLoader, setbuttonLoader] = useState(false);

  const [newformuserNameErr, setnewformuserNameErr, newformuserNameErrref] =
    useState(false);
  const [selectedPlatform2, setSelectedPlatform2] = useState("whatsApp");
  const [newformmobileErr, setnewformmobileErr, newformmobileErrref] =
    useState(false);
  const [
    newformmediumValueErr,
    setnewformmediumValueErr,
    newformmediumValueErrref,
  ] = useState(false);
  const [newformmessageErr, setnewformmessageErr, newformmessageErrref] =
    useState(false);
  const [newformmobilecodeErr, setnewformmobilecodeErr] = useState(false);
  const [NewFormMobileValue, setNewFormMobileValue] = useState("");
  const [platformInput, setPlatformInput, platformInputref] = useState("");

  const [validationErr, setvalidationErr, validationErrref] = useState("");
  const [NewFormNMobileCode, setNewFormNMobileCode] = useState("");
  const [NewFormcountry, setNewFormcountry] = useState("");
  const [menuopen, setMenuopn] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);

  const [activeSections, setActiveSections] = useState({
    section1: true,
    section2: false,
    section3: false,
    section4: false,
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const NewFormValue = {
    newformmediumValue: "",
    newformmedium: "whatsApp",
    newformmessage: "",
    newformmobile: "",
    newformuserName: "",
    newformmobilecode: "",
  };

  const [newValue, setnewValue, newValueref] = useState(NewFormValue);

  const { newformuserName, newformmessage } = newValue;

  const [errors, setErrors] = useState({});

  const refs = {
    "Meme Coin": useRef(null),
    ICO: useRef(null),
    Gaming: useRef(null),
    Bot: useRef(null),
    "Mobile App": useRef(null),
    MLM: useRef(null),
    "Own BlockChain": useRef(null),
    "Decentralized Exchange & Defi": useRef(null),
    NFT: useRef(null),
    "Cryto Exchange": useRef(null),
    "Crypto Payment": useRef(null),
  };

  const scrollToImage = (val) => {
    if (refs[val]) {
      refs[val]?.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  const cancelpopup = () => {};

  const handleActiveSection = (section) => {
    setActiveSection(section);
    setMenuopn(false);
    setActiveSections((prevState) => ({
      section1: section === "about",
      section2: section === "services",
      section3: section === "projects",
      section4: section === "contact",
    }));
  };

  // const validate = async (formData) => {
  //   try {
  //     var error = {};
  //     const countryCodeLength = formData.newformmobilecode.length;
  //     const actualMobileLength =
  //       formData.newformmobile.length - countryCodeLength;

  //     if (formData.newformuserName.trim() === "") {
  //       setnewformuserNameErr(true);
  //       error.newformuserName = "Must enter the field";
  //       setvalidationErr(error);
  //       return;
  //     } else if (formData.newformuserName.length < 3) {
  //       setnewformuserNameErr(true);
  //       error.newformuserName = "Invalid username, Must be 3-50 characters";
  //       setvalidationErr(error);
  //       return;
  //     }

  //     else if (formData.newformmobile.trim() === "") {
  //       setnewformuserNameErr(false);
  //       setnewformmobileErr(true);
  //       error.newformmobile = "Must enter the field";
  //       setvalidationErr(error);
  //       return;
  //     } else if (actualMobileLength < 7) {
  //       setnewformuserNameErr(false);
  //       setnewformmobileErr(true);
  //       error.newformmobile =
  //         "Invalid number, Must be at least 7 digits excluding country code";
  //       setvalidationErr(error);
  //       return;
  //     }

  //     else if (
  //       selectedPlatform2 === "email" &&
  //       (platformInputref?.current.trim() === "" ||
  //         platformInputref?.current.startsWith(" ")) // Check for leading space
  //     ) {
  //       setnewformmobileErr(false);
  //       setnewformmediumValueErr(true);
  //       error.newformmediumValue = "Email can't start with a space";
  //       setvalidationErr(error);
  //       return;
  //     } else if (
  //       selectedPlatform2 === "email" &&
  //       !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
  //         platformInputref?.current
  //       )
  //     ) {
  //       setnewformmediumValueErr(true);
  //       error.newformmediumValue = "Invalid email format";
  //       setvalidationErr(error);
  //       return;
  //     }

  //     else if (["whatsApp", "skype", "telegram"].includes(selectedPlatform2)) {
  //       if (platformInputref?.current.trim() === "") {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = "Must enter the field";
  //         setvalidationErr(error);
  //         return;
  //       } else if (
  //         selectedPlatform2 === "whatsApp" &&
  //         platformInputref?.current.length < 7
  //       ) {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
  //         setvalidationErr(error);
  //         return;
  //       } else if (
  //         selectedPlatform2 === "skype" &&
  //         platformInputref?.current.length < 5
  //       ) {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = `Skype ID / Number must be at least 5 characters`;
  //         setvalidationErr(error);
  //         return;
  //       } else if (platformInputref?.current.length < 5) {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = `Telegram ID / Number must be at least 5 characters`;
  //         setvalidationErr(error);
  //         return;
  //       } else {
  //         setnewformuserNameErr(false);
  //         setnewformmediumValueErr(false);
  //       }
  //     }
  //     if (formData.newformmessage.trim() === "") {
  //       setnewformmediumValueErr(false);
  //       setnewformmobileErr(false);
  //       setnewformmessageErr(true);
  //       error.newformmessage = "Must enter the field";
  //       setvalidationErr(error);
  //     } else if (formData.newformmessage.length < 3) {
  //       setnewformmessageErr(true);
  //       error.newformmessage = "Message must contain at least 3 characters";
  //       setvalidationErr(error);
  //     } else if (formData.newformmessage.length > 250) {
  //       setnewformmessageErr(true);
  //       error.newformmessage = "Message can't exceed 250 characters";
  //       setvalidationErr(error);
  //     } else {
  //       setnewformmessageErr(false);
  //     }

  //     setvalidationErr(error);
  //   } catch (error) {
  //   }
  // };

  // const sendServiceContact = async (e) => {
  //   try {
  //     e.preventDefault();
  //     if (
  //       newValueref.current.newformuserName !== "" &&
  //       newformuserNameErrref.current === false &&
  //       newformmessageErrref.current === false &&
  //       newformmobileErrref.current === false &&
  //       newformmediumValueErrref.current == false &&
  //       newformmobilecodeErr === false &&
  //       newValueref.current.newformmessage != ""
  //     ) {
  //       newValueref.current.newformmedium = selectedPlatform2;
  //       newValueref.current.newformmediumValue = platformInputref?.current;

  //       var obj = {
  //         apiUrl: httpService.sendServiceContactDetails,
  //         payload: newValueref.current,
  //       };
  //       var messageSent = await sendcontactpageContacts(obj);
  //       setbuttonLoader(false);
  //       newValueref.current.newformuserName = "";
  //       newValueref.current.newformmessage = "";
  //       newValueref.current.newformmobile = "";
  //       newValueref.current.newformmobilecode = "";
  //       setNewFormMobileValue("");
  //       setPlatformInput("");
  //       setNewFormNMobileCode("");
  //       setNewFormcountry();
  //       handleNewFormMobile("", "", "", "");
  //       if (messageSent.status == true) {
  //         toast.success(messageSent.Message);
  //         cancelpopup();
  //       } else {
  //         toast.error(messageSent.Message);
  //         cancelpopup();
  //       }
  //     } else {
  //       validate(newValueref.current);
  //     }
  //   } catch (err) {}
  // };

  const validate = async (formData) => {
    try {
      var error = {};
      const countryCodeLength = formData?.newformmobilecode?.length;

      const actualMobileLength =
        formData.newformmobile.length - countryCodeLength;

      if (formData.newformuserName.trim() === "") {
        setnewformuserNameErr(true);
        error.newformuserName = "Name is a required field";
        setvalidationErr(error);
      } else if (formData.newformuserName.length < 3) {
        setnewformuserNameErr(true);

        error.newformuserName = "Invalid username, Must be 3-50 characters";
        setvalidationErr(error);
      } else {
        setnewformuserNameErr(false);
      }

      if (formData.newformmobile.trim() === "") {
        // setnewformuserNameErr(false);
        setnewformmobileErr(true);
        error.newformmobile = "Mobile Number is a required field";
        setvalidationErr(error);
      } else if (actualMobileLength < 7) {
        // setnewformuserNameErr(false);
        setnewformmobileErr(true);
        error.newformmobile =
          "Invalid number, Must be at least 7 digits excluding country code";
        setvalidationErr(error);
      } else {
        setnewformmobileErr(false);
      }

      if (
        (selectedPlatform2 === "email" && platformInputref.current === "") ||
        platformInputref.current.length == 0
      ) {
        // setnewformmobileErr(false);
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Contact Medium is a required field";
        setvalidationErr(error);
      } else if (
        selectedPlatform2 === "email" &&
        !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
          platformInputref.current
        )
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Invalid email format";
        setvalidationErr(error);
      } else if (
        ["whatsApp", "skype", "telegram"].includes(selectedPlatform2)
      ) {
        if (platformInputref.current.trim() === "") {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Contact Medium is a required field";
          setvalidationErr(error);
        } else if (
          selectedPlatform2 === "whatsApp" &&
          platformInputref.current.length < 7
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
          setvalidationErr(error);
        } else if (
          selectedPlatform2 === "skype" &&
          platformInputref.current.length < 5
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Skype ID / Number must be at least 5 characters`;
          setvalidationErr(error);
        } else if (platformInputref.current.length < 5) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Telegram ID / Number must be at least 5 characters`;
          setvalidationErr(error);
        } else {
          // setnewformuserNameErr(false);
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (formData.newformmessage.trim() === "") {
        // setnewformmediumValueErr(false);
        setnewformmessageErr(true);
        error.newformmessage = "Message is a required field";
        setvalidationErr(error);
      } else if (formData.newformmessage.length < 3) {
        setnewformmessageErr(true);
        error.newformmessage = "Message must contain at least 3 characters";
        setvalidationErr(error);
      } else if (formData.newformmessage.length > 250) {
        setnewformmessageErr(true);
        error.newformmessage = "Message can't exceed 250 characters";
        setvalidationErr(error);
      } else {
        setnewformmessageErr(false);
      }

      setvalidationErr(error);
    } catch (error) {
      console.error(error);
    }
  };

  const sendServiceContact = async (e) => {
    try {
      e.preventDefault();
      validate(newValueref.current);
      console.log(newValueref.current);
      console.log(
        newValueref.current.newformuserName,
        newformuserNameErrref.current,
        newformmessageErrref.current,
        newformmobileErrref.current,
        newformmediumValueErrref.current,
        newValueref.current.newformmessage
      );

      if (
        newValueref.current.newformuserName !== "" &&
        newformuserNameErrref.current === false &&
        newformmessageErrref.current === false &&
        newformmobileErrref.current === false &&
        newformmediumValueErrref.current == false &&
        newValueref.current.newformmessage != ""
      ) {
        // setbuttonLoader(true);

        newValueref.current.newformmedium = selectedPlatform2;
        newValueref.current.newformmediumValue = platformInputref.current;
        console.log("values submit finnaly ===>>>", newValueref.current);
        // return;
        var obj = {
          apiUrl: httpService.sendServiceContactDetails,
          payload: newValueref.current,
        };
        var messageSent = await sendcontactpageContacts(obj);
        setbuttonLoader(false);

        if (messageSent.status == true) {
          showSuccessToast(messageSent.Message || "Message sent successfully!");
          setnewValue(NewFormValue);
          setNewFormMobileValue("");
          setPlatformInput("");
          setSelectedPlatform2("whatsApp");
          // newValueref.current.newformuserName = "";
          // newValueref.current.newformmessage = "";
          // newValueref.current.newformmobile = "";
          // newValueref.current.newformmobilecode = "";
          // setNewFormMobileValue("");
          // setPlatformInput("");
        } else {
          showErrorToast(messageSent.Message || "Failed to send message.");
        }
      } else {
        validate(newValueref.current);
      }
    } catch (errr) {
      console.log("errr", errr);
    }
  };

  // const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
  //   setNewFormMobileValue(value);
  //   setNewFormNMobileCode(countryObj.dialCode);
  //   setNewFormcountry(countryObj.name);
  //   newValueref.current["newformmobilecode"] = countryObj.dialCode;
  //   newValueref.current["newformmobile"] = value;
  //   newValueref.current["NewFormcountry"] = countryObj.name;
  //   setSelectedPlatform2("whatsApp");
  //   setPlatformInput("");
  //   validate(newValueref.current);
  // };

  const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
    setNewFormMobileValue(value);
    newValueref.current["newformmobilecode"] = countryObj.dialCode;
    newValueref.current["newformmobile"] = value;
    newValueref.current["NewFormcountry"] = countryObj.name;
    setSelectedPlatform2("whatsApp");
    setPlatformInput("");
    // validate(newValueref.current);
    validateNewFormMobile(value, countryObj.dialCode);
    console.log(newValueref.current);
  };

  const validateNewFormMobile = (mobileValue, dialCode) => {
    let error = {};
    const countryCodeLength = dialCode.length;
    const actualMobileLength = mobileValue.length - countryCodeLength;

    if (mobileValue.trim() === "") {
      setnewformmobileErr(true);
      error.newformmobile = "Mobile Number is a required field";
    } else if (actualMobileLength < 7) {
      setnewformmobileErr(true);
      error.newformmobile =
        "Invalid number, must be at least 7 digits excluding country code";
    } else {
      setnewformmobileErr(false);
    }

    setvalidationErr(error);
  };

  const handlePlatformSelect = (e, platform) => {
    e.preventDefault();
    setSelectedPlatform2(platform);
    setPlatformInput("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Remove leading spaces for all fields
    const trimmedValue = value.replace(/^\s+/, "");

    setFormData((prevData) => ({
      ...prevData,
      [name]: trimmedValue,
    }));

    // Clear the error if the input becomes valid
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      // Validation logic for each field
      if (name === "name" && trimmedValue.trim() !== "") {
        delete updatedErrors.name;
      }
      if (name === "email") {
        // Ensure no leading space and valid email format
        if (trimmedValue.trim() !== "" && /\S+@\S+\.\S+/.test(trimmedValue)) {
          delete updatedErrors.email;
        } else if (value.startsWith(" ")) {
          updatedErrors.email = "";
        }
      }
      if (name === "phone" && /^\d{7}$/.test(trimmedValue)) {
        delete updatedErrors.phone;
      }
      if (name === "message" && trimmedValue.trim().length >= 3) {
        delete updatedErrors.message;
      }

      return updatedErrors;
    });
  };

  // const handlePlatformInputChange = (e) => {
  //   const value = e.target.value;
  //   if (
  //     (e.key === " " && e.target.selectionStart === 0) ||
  //     e.target.value.startsWith(" ")
  //   ) {
  //     e.target.value = e.target.value.trimStart();
  //   }

  //   setPlatformInput(value);
  //   if (value && value.length > 0) {
  //     setnewformmediumErr(false);
  //     setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
  //   } else {
  //     setnewformmediumErr(true);
  //     setvalidationErr((prev) => ({
  //       ...prev,
  //       newformmedium: "Must enter the field",
  //     }));
  //   }
  //   validate(newValueref?.current);
  //   if (
  //     selectedPlatform2 === "email" &&
  //     !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref?.current)
  //   ) {
  //     validate(newValueref?.current);
  //   }
  // };

  // const handleKeyPress = (e, maxLength, type) => {
  //   const allowedKeys = [
  //     "Backspace",
  //     "Delete",
  //     "Tab",
  //     "Escape",
  //     "Enter",
  //     "ArrowLeft",
  //     "ArrowRight",
  //   ];

  //   if (e.target.value.length >= maxLength && !allowedKeys.includes(e.key)) {
  //     e.preventDefault();
  //     return;
  //   }

  //   if (type === "email") {
  //     const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
  //     if (!validEmailChars.test(e.key) && !allowedKeys.includes(e.key)) {
  //       e.preventDefault();
  //     }
  //     return;
  //   }

  //   if (type === "number") {
  //     const cursorPosition = e.target.selectionStart;

  //     if (e.key === " " && cursorPosition === 0) {
  //       e.preventDefault();
  //       return;
  //     }

  //     if (
  //       !/[0-9 ]/.test(e.key) &&
  //       !(e.key === "+" && cursorPosition === 0) &&
  //       !allowedKeys.includes(e.key)
  //     ) {
  //       e.preventDefault();
  //     }
  //     return;
  //   }

  //   if (type === "text") {
  //     const cursorPosition = e.target.selectionStart;

  //     if (e.key === " " && cursorPosition === 0) {
  //       e.preventDefault();
  //       return;
  //     }

  //     if (e.target.value.length < maxLength || allowedKeys.includes(e.key)) {
  //       return;
  //     }

  //     e.preventDefault();
  //   }
  // };

  const handlePlatformInputChange = (e) => {
    const value = e.target.value;
    setPlatformInput(value);

    let error = {};
    let hasError = false;

    // Basic validation
    if (!value) {
      error.newformmediumValue = "This field is required.";
      hasError = true;
    } else if (
      selectedPlatform2 === "email" &&
      !/^[^\s@]+@[^\s@]+\.(com)$/i.test(value)
    ) {
      error.newformmediumValue = "Invalid email format.";
      hasError = true;
    } else if (selectedPlatform2 === "whatsApp" && value.length < 7) {
      error.newformmediumValue =
        "Invalid number, Must be at least 7 digits excluding country code";
      hasError = true;
    } else if (
      ["telegram", "skype"].includes(selectedPlatform2) &&
      value.length < 5
    ) {
      error.newformmediumValue = `${selectedPlatform2} ID must be at least 5 characters.`;
      hasError = true;
    }

    setvalidationErr(error);
    setnewformmediumValueErr(hasError);

    // if (value && value.length > 0) {
    //   setnewformmediumErr(false);
    //   setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
    // } else {
    //   setnewformmediumErr(true);
    //   setvalidationErr((prev) => ({
    //     ...prev,
    //     newformmedium: "Must enter the field",
    //   }));
    // }
    // // newValueref.current.newformmessage = "";
    // validate(newValueref.current);
    // if (
    //   selectedPlatform2 === "email" &&
    //   !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref.current)
    // ) {
    //   validate(newValueref.current);
    // }
  };

  const handleKeyPress = (e, maxLength, type) => {
    if (
      e.target.value.length >= maxLength &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(e.key)
    ) {
      e.preventDefault();
      return;
    }

    if (type === "email") {
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
      if (
        !validEmailChars.test(e.key) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "number") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      // Prevent space at the start
      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }

      // Allow only digits, plus symbol at the start, spaces in the middle, and control keys
      if (
        !/[0-9 ]/.test(e.key) &&
        !(e.key === "+" && cursorPosition === 0) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "text") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }
      if (
        value.length < maxLength ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        return;
      }

      e.preventDefault();
    }
  };

  // const handleNewFormChange = async (e) => {
  //   try {
  //     if (
  //       (e.key === " " && e.target.selectionStart === 0) ||
  //       e.target.value.startsWith(" ")
  //     ) {
  //       e.target.value = e.target.value.trimStart();
  //     }

  //     const { name, value } = e.target;
  //     const updatedFormData = { ...newValue, [name]: value };
  //     setnewValue(updatedFormData);

  //     await validate(updatedFormData);

  //     if (selectedPlatform2 && !platformInputref?.current) {
  //       setnewformmediumValueErr(true);
  //     } else {
  //       setnewformmediumValueErr(false);
  //     }

  //     if (name === "newformmessage" && !value.trim()) {
  //       setnewformmessageErr(true);
  //     } else if (name === "newformmessage") {
  //       setnewformmessageErr(false);
  //     }
  //   } catch (error) {
  //     console.error("Error during form validation:", error);
  //   }
  // };
  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      console.log("sdfasfasf", e.target.value);

      // Update form state
      let formData = { ...newValue, [name]: value };
      setnewValue(formData);

      // Validate only `newformmessage`
      if (name === "newformmessage") {
        let error = { ...validationErr };

        if (!value.trim()) {
          error.newformmessage = "Message is a required field";
          setnewformmessageErr(true);
        } else if (value.length < 3) {
          error.newformmessage = "Message must contain at least 3 characters";
          setnewformmessageErr(true);
        } else if (value.length > 250) {
          error.newformmessage = "Message can't exceed 250 characters";
          setnewformmessageErr(true);
        } else {
          delete error.newformmessage; // Remove error if valid
          setnewformmessageErr(false);
        }

        setvalidationErr(error);
      }

      // e.preventDefault();
      // const { name, value } = e.target;
      // let formData = { ...newValue, ...{ [name]: value } };
      // setnewValue(formData);
      // await validate(formData);

      // if (selectedPlatform2 && !platformInputref.current) {
      //   setnewformmediumValueErr(true);
      // } else {
      //   setnewformmediumValueErr(false);
      // }

      // if (name === "newformmessage") {
      //   if (!value.trim()) {
      //     setnewformmessageErr(true);
      //   } else {
      //     setnewformmessageErr(false);
      //   }
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const menuopenClose = () => {
    setMenuopn(true);
  };

  const validateForm = () => {
    const newErrors = {};
    const { name, email, phone, message } = formData;

    if (!name.trim()) {
      newErrors.name = "Name is required.";
    }
    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid.";
    }
    if (!phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{7}$/.test(phone)) {
      newErrors.phone = "Phone number must be 7 digits.";
    }
    if (!message.trim()) {
      newErrors.message = "Message must be at least 3 characters long.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Proceed with form submission (e.g., send data to server)
      console.log("Form submitted:", formData);
      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    }
  };

  const handleCloseMet = () => {
    setMenuopn(false);
  };

  const navigate = useNavigate();

  const handleAboutLogoClick = () => {
    localStorage.setItem("cameFromAbout", "true");
    navigate("/");
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          {/* <h4 className="toast-title">Success!</h4> */}
          <p className="toast-message m-0">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          {/* <h4 className="toast-title">Error!</h4> */}
          <p className="toast-message m-0">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  return (
    <>
      {" "}
      <div className="main-bg contact-bg">
        <section
          className={`${
            menuopen === true ? "menuopenzindex" : "menuclosezindex"
          }`}
        >
          <header className="main-header scrolled header-wrapper">
            <AppBar position="static" className="header_secondsec">
              <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
                <div className="hd_navigation">
                  <div
                    className="d-flex hd_nav_lft"
                    onClick={handleAboutLogoClick}
                  >
                    <Link className="logo-wrapper">
                      <img src={Logo} className="img-fluid" alt="logo" />
                    </Link>
                  </div>

                  <div className="hd_nav_links_cntr">
                    <Link to="/about" className="hd_nav_link">
                      About
                    </Link>
                    <Link to="/services" className="hd_nav_link">
                      Services
                    </Link>
                    <Link to="/projects" className="hd_nav_link">
                      Projects
                    </Link>
                    <Link to="/testimonials" className="hd_nav_link">
                      Testimonials
                    </Link>
                  </div>

                  <div className="rightside_menu">
                    <div className="header_btn_wrap">
                      <button
                        className="header-btn"
                        onClick={() => navigate("/contact-us")}
                      >
                        <span className="phone_icon">
                          <FaPhoneAlt />
                        </span>
                        <span>Contact</span>
                      </button>

                      <button
                        className="header-btn"
                        onClick={() =>
                          window.open(
                            "https://beleaftechnologies.com/",
                            "_blank"
                          )
                        }
                      >
                        <span className="web_icon">
                          <TbWorld />
                        </span>
                        <span>Website</span>
                      </button>
                    </div>
                  </div>

                  <div className="header_bars" onClick={handleMobileMenuOpen}>
                    <i className="fa-solid fa-bars"></i>
                  </div>
                </div>
              </Toolbar>
            </AppBar>

            <Drawer
              anchor="left"
              open={mobileMenuOpen}
              onClose={handleMobileMenuClose}
              className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
            >
              <div className={` ${classes.mobileMenu}`}>
                <div className="logo_new_sectio mobile_menu_icon">
                  <div
                    className="mobile_logo_wrap"
                    onClick={handleAboutLogoClick}
                  >
                    <img src={Logo} alt="logo" />
                  </div>
                </div>

                <div className="menu_statis">
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/about">
                      About
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/services">
                      Services
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/projects">
                      Projects
                    </Link>
                  </ListItem>
                  {/* <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/testimonials">
                      Testimonials
                    </Link>
                  </ListItem> */}

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="phone_icon">
                        <FaPhoneAlt />
                      </span>
                      <span>Contact</span>
                    </button>
                  </ListItem>

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span className="">Website</span>
                    </button>
                  </ListItem>
                </div>
              </div>
            </Drawer>
          </header>

          <main>
            <div className="header-wrapper section-wrapper">
              <div className="container-fluid">
                <div className="row NewHome_main" style={{ height: "100%" }}>
                  <div className="col-lg-10 col-xl-12 NewHome-main-col">
                    <div
                      className="getting_card_content"
                      style={{ paddingBottom: "70px" }}
                    >
                      <span className="getcard_sub_subhead padding-right">
                        How to contact us.
                      </span>
                      <h1>Contacts</h1>
                    </div>
                    <div className="contact_formmain">
                      <form>
                        <div className="row m-0">
                          <div className="col-lg-12 form-container">
                            <input
                              type="text"
                              // name="name"
                              placeholder="Enter your name"
                              className="styled-input"
                              name="newformuserName"
                              autoComplete="off"
                              value={newformuserName}
                              max="50"
                              maxLength="50"
                              // onChange={handleNewFormChange}
                              // onBlur={(e) => handleKeyPress(e, 50, "text")}
                              onChange={(e) => {
                                const value = e.target.value;
                                setnewValue((prev) => ({
                                  ...prev,
                                  newformuserName: value,
                                }));

                                if (value.trim() === "") {
                                  setnewformuserNameErr(true);
                                  setvalidationErr((prev) => ({
                                    ...prev,
                                    newformuserName: "Name is a required field",
                                  }));
                                } else if (value.length < 3) {
                                  setnewformuserNameErr(true);
                                  setvalidationErr((prev) => ({
                                    ...prev,
                                    newformuserName:
                                      "Invalid username, Must be 3-50 characters",
                                  }));
                                } else {
                                  setnewformuserNameErr(false);
                                  setvalidationErr((prev) => ({
                                    ...prev,
                                    newformuserName: "",
                                  }));
                                }
                              }}
                              onKeyPress={(e) => handleKeyPress(e, 50, "text")}
                            />
                            {newformuserNameErrref.current &&
                            newformuserNameErrref.current === true ? (
                              <div className="text-danger mt-3">
                                {" "}
                                {validationErrref.current.newformuserName}{" "}
                              </div>
                            ) : (
                              ""
                            )}
                            {/* {errors.name && <span>{errors.name}</span>} */}
                          </div>
                          <div className="col-lg-6 form-container">
                            <PhoneInput
                              country={"us"}
                              value={NewFormMobileValue}
                              inputProps={{
                                name: "phonenumber",
                                required: true,
                              }}
                              autoComplete="off"
                              className="form-phone landing__form-input margin-bottom-land contact-us-input contact-us-phone"
                              // onChange={(
                              //   value,
                              //   countryObj,
                              //   e,
                              //   formattedValue
                              // ) =>
                              //   handleNewFormMobile(
                              //     value,
                              //     countryObj,
                              //     e,
                              //     formattedValue
                              //   )
                              // }
                              onChange={(
                                value,
                                countryObj,
                                e,
                                formattedValue
                              ) =>
                                handleNewFormMobile(
                                  value,
                                  countryObj,
                                  e,
                                  formattedValue
                                )
                              }
                            />
                            {newformmobileErrref.current &&
                            newformmobileErrref.current === true ? (
                              <div className="text-danger mt-3">
                                {validationErrref.current.newformmobile}
                              </div>
                            ) : (
                              ""
                            )}
                            {/* {errors.email && <span>{errors.email}</span>} */}
                          </div>
                          <div className="col-lg-6 form-container text-left form-pl-0">
                            <div className="form-contact-medium contact-us-input mt-2 contact-med-flex">
                              <button
                                type="button"
                                className="dropdown-toggle landing__form-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {selectedPlatform2 == "whatsApp" ? (
                                  <i className="fa-brands fa-whatsapp"></i>
                                ) : selectedPlatform2 == "telegram" ? (
                                  <i className="fa-brands fa-telegram"></i>
                                ) : selectedPlatform2 == "skype" ? (
                                  <i className="fa-brands fa-skype"></i>
                                ) : selectedPlatform2 == "email" ? (
                                  <i
                                    className="fa fa-envelope"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="dropdown-menu landing__form-drop-menu">
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "whatsApp")
                                  }
                                >
                                  <i className="fa-brands fa-whatsapp"></i>
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "telegram")
                                  }
                                >
                                  <i className="fa-brands fa-telegram"></i>
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "skype")
                                  }
                                >
                                  <i className="fa-brands fa-skype"></i>
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={(e) =>
                                    handlePlatformSelect(e, "email")
                                  }
                                >
                                  <i
                                    className="fa fa-envelope"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>

                              {/* {selectedPlatform2 && (
                                <input
                                  type={
                                    selectedPlatform2 === "whatsApp"
                                      ? "number"
                                      : "text"
                                  }
                                  className="landing__contact-medium-input contact-medium-width"
                                  placeholder={`Enter your ${selectedPlatform2} ${
                                    selectedPlatform2 == "email"
                                      ? "Address"
                                      : selectedPlatform2 === "whatsApp"
                                      ? "number"
                                      : "number/ID"
                                  }`}
                                  maxLength={
                                    selectedPlatform2 === "email"
                                      ? 250
                                      : selectedPlatform2 === "whatsApp"
                                      ? 15
                                      : 32
                                  }
                                  value={platformInputref.current}
                                  autoComplete="off"
                                  onChange={handlePlatformInputChange}
                                  onBlur={(e) =>
                                    handleKeyPress(
                                      e,
                                      selectedPlatform2 === "email"
                                        ? 250
                                        : selectedPlatform2 === "whatsApp"
                                        ? 15
                                        : 32,
                                      selectedPlatform2 === "email"
                                        ? "email"
                                        : selectedPlatform2 === "whatsApp"
                                        ? "number"
                                        : "text"
                                    )
                                  }p
                                />
                              )} */}
                              {selectedPlatform2 && (
                                <input
                                  type="text"
                                  className="landing__contact-medium-input w-100"
                                  placeholder={`Enter your ${selectedPlatform2} ${
                                    selectedPlatform2 == "email"
                                      ? "Address"
                                      : selectedPlatform2 === "whatsApp"
                                      ? "number"
                                      : "number / ID"
                                  }`}
                                  maxLength={
                                    selectedPlatform2 === "email"
                                      ? 250
                                      : selectedPlatform2 === "whatsApp"
                                      ? 15
                                      : 32
                                  }
                                  value={platformInputref.current}
                                  autoComplete="off"
                                  onChange={handlePlatformInputChange}
                                  onKeyPress={(e) =>
                                    handleKeyPress(
                                      e,
                                      selectedPlatform2 === "email"
                                        ? 250
                                        : selectedPlatform2 === "whatsApp"
                                        ? 15
                                        : 32,
                                      selectedPlatform2 === "email"
                                        ? "email"
                                        : selectedPlatform2 === "whatsApp"
                                        ? "number"
                                        : "text"
                                    )
                                  }
                                />
                              )}
                            </div>
                            {newformmediumValueErrref.current &&
                            newformmediumValueErrref.current === true ? (
                              <div className="text-danger mt-3">
                                {validationErrref.current.newformmediumValue}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-lg-12 form-container">
                            <textarea
                              // name="message"
                              className="contact-textarea"
                              placeholder="Enter your message"
                              // value={formData.message}
                              // className="styled-input"
                              // onChange={handleChange}
                              name="newformmessage"
                              value={newformmessage}
                              max="250"
                              maxLength="250"
                              autoComplete="off"
                              // onChange={handleNewFormChange}
                              // onBlur={(e) => handleKeyPress(e, 250, "text")}
                              onChange={handleNewFormChange}
                              onKeyPress={(e) => handleKeyPress(e, 250, "text")}
                            />
                            {newformmessageErrref.current == true ? (
                              <div className="text-danger mt-3">
                                {validationErrref.current.newformmessage}
                              </div>
                            ) : (
                              ""
                            )}
                            {/* {errors.message && <span>{errors.message}</span>} */}
                          </div>

                          <div className="submit_mainbtn">
                            {buttonLoader == true ? (
                              <button className="submit_btn" disabled>
                                Loading...{" "}
                              </button>
                            ) : (
                              <button
                                className="submit_btn"
                                onClick={sendServiceContact}
                              >
                                Submit{" "}
                              </button>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </section>
      </div>
    </>
  );
};

export default Contact;
